import React, {useState} from 'react';
import useBroadcastChannel from '../components/useBroadcastChannel.js'

// Interface for Google login success data
interface GoogleLoginSuccessData {
    accountCreated: boolean;
    name: string;
    email: string;
}

// Interface for broadcast message data
interface BroadcastMessageData {
    message: string;
    accountCreated: boolean;
    name: string;
    email: string;
}

// Interface for broadcast message
interface BroadcastMessage {
    data: BroadcastMessageData;
}

// Interface for component props
interface GoogleLoginProps {
    buttonText: string;
    onSuccess: (data: GoogleLoginSuccessData) => void;
}

let windowObjectReference: Window | null = null;
let previousUrl: string | null = null;

export default function GoogleLogin({buttonText, onSuccess}: GoogleLoginProps){

    const { broadcast } = useBroadcastChannel({
        channelName: "wts-channel",
        messageHandler: (message: BroadcastMessage) => {

            // const dataForAccountCreate = {
            //     message: 'wts-google-logged-in',
            //     name: req.user.name,
            //     email: req.user.name, 
            //     accountCreated: req.user.google.account_created
            //   }
          
            if (message.data.message === 'wts-google-logged-in') {
                onSuccess({
                    accountCreated: message.data.accountCreated,
                    name: message.data.name,
                    email: message.data.email
                });
            }
            else {
                console.log(`Unknown broadcase message: ${message.data}`);
            }
        },
    });

    // code is 'inspired' by https://dev.to/dinkydani21/how-we-use-a-popup-for-google-and-outlook-oauth-oci
    function loginWithGoogle() {

        openSignInWindow('/auth/google', 'Authenticate With Google');
    }

    function openSignInWindow(url: string, name: string) {

        // remove existing event listeners
        window.removeEventListener('message', receiveMessage);

        // window features
        const strWindowFeatures =
            'toolbar=no, menubar=no, width=600, height=700, top=100, left=100';

        if (windowObjectReference === null || windowObjectReference.closed) {
            // if the pointer to the window object in memory does not exist
            // or if such pointer exists but the window was closed
            windowObjectReference = window.open(url, name, strWindowFeatures);

        } else if (previousUrl !== url) {
            // if the resource to load is different,
            // then we load it in the already opened secondary window and then
            // we bring such window back on top/in front of its parent window.
            windowObjectReference = window.open(url, name, strWindowFeatures);
            windowObjectReference!.focus();
        } else {
            // else the window reference must exist and the window
            // is not closed; therefore, we can bring it back on top of a-n-y other
            // window with the focus() method. There would be no need to re-create
            // the window or to reload the referenced resource.
            windowObjectReference.focus();
        }

        // add the listener for receiving a message from the popup
        window.addEventListener('message', (event: MessageEvent) => receiveMessage(event), false);

        // assign the previous URL
        previousUrl = url;
    };

    function receiveMessage(event: MessageEvent) {

        console.log(`**** Artem normal function receiveMessage`)

/*
        // Do we trust the sender of this message? (might be
        // different from what we originally opened, for example).
        if (event.origin !== BASE_URL) {
          return;
        }
        const { data } = event;
        // if we trust the sender and the source is our popup
        if (data.source === 'lma-login-redirect') {
          // get the URL params and redirect to our server to use Passport to auth/login
          const { payload } = data;
          const redirectUrl = `/auth/google/login${payload}`;
          window.location.pathname = redirectUrl;
        }
*/          
    };

    return (<>
        <div>
            <button onClick={loginWithGoogle} className="btn btn-block"><span className="fa fa-google"></span>&nbsp;&nbsp;{buttonText}</button>
        </div>
    </>)
}
